import React from 'react';
import { Outlet } from 'react-router-dom';

import { FindPasswordProvider } from '@MP/features/auth';

const FindPasswordPage = () => {
  return (
    <FindPasswordProvider>
      <Outlet />
    </FindPasswordProvider>
  );
};

export default FindPasswordPage;
